import { render, staticRenderFns } from "./TextBoxDesigner.vue?vue&type=template&id=6fbeac2e&scoped=true&"
import script from "./TextBoxDesigner.vue?vue&type=script&lang=js&"
export * from "./TextBoxDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbeac2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fbeac2e')) {
      api.createRecord('6fbeac2e', component.options)
    } else {
      api.reload('6fbeac2e', component.options)
    }
    module.hot.accept("./TextBoxDesigner.vue?vue&type=template&id=6fbeac2e&scoped=true&", function () {
      api.rerender('6fbeac2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/formField/TextBoxDesigner.vue"
export default component.exports